import { render, staticRenderFns } from "./basealert.vue?vue&type=template&id=5326284a&scoped=true&"
import script from "./basealert.vue?vue&type=script&lang=js&"
export * from "./basealert.vue?vue&type=script&lang=js&"
import style0 from "./basealert.vue?vue&type=style&index=0&id=5326284a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326284a",
  null
  
)

export default component.exports